(() => {
  const menuSelector = '[data-reytel-mega-menu]';
  const imageSelector = 'img[data-reytel-mega-menu-image]';

  function hydrate(menu) {
    if (!menu || menu.dataset.reytelMegaMenuLoaded === 'true') return;

    menu.querySelectorAll(imageSelector).forEach((image) => {
      image.loading = 'eager';

      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }

      if (image.dataset.src) {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      }

      image.dataset.reytelMegaMenuImageLoaded = 'true';
    });

    menu.dataset.reytelMegaMenuLoaded = 'true';
    menu.dispatchEvent(new CustomEvent('reytel:mega-menu-loaded'));
  }

  function register(menu) {
    if (menu.dataset.reytelMegaMenuRegistered === 'true') return;

    const item = menu.closest('.header-navigation > li');
    if (!item) return;

    menu.dataset.reytelMegaMenuRegistered = 'true';
    const load = () => hydrate(menu);

    item.addEventListener('pointerenter', load, { once: true, passive: true });
    item.addEventListener('pointerdown', load, { once: true, passive: true });
    item.addEventListener('focusin', load, { once: true, passive: true });
  }

  function scan(root = document) {
    if (root.matches && root.matches(menuSelector)) register(root);
    if (root.querySelectorAll) root.querySelectorAll(menuSelector).forEach(register);
  }

  window.reytelLoadMegaMenu = hydrate;
  window.reloadMegaMenuImages = scan;

  scan();
})();

